import * as form from '../form';

export const legalInvestigationsRevoked = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Agency: form.text(xitem.Agency),
        AgencyExplanation: form.textarea(xitem.AgencyExplanation), // PVQ Only
        AgencyNotApplicable: form.notapplicable(xitem.AgencyNotApplicable), // SF Only
        Date: form.datecontrol(xitem.Date),
        DateNotApplicable: form.notapplicable(xitem.DateNotApplicable),
        Explanation: form.textarea(xitem.Explanation)
      },
    };
  });
  // PVQ Only
  const denialItems = ((data.DenialList || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Agency: form.radio(xitem.Agency),
        AgencyExplanation: form.textarea(xitem.AgencyExplanation),
        AgencyNotApplicable: form.notapplicable(xitem.AgencyNotApplicable), // SF Only
        Date: form.datecontrol(xitem.Date),
        DateNotApplicable: form.notapplicable(xitem.DateNotApplicable),
        Explanation: form.textarea(xitem.Explanation)
      },
    };
  });
  // PVQ Only
  const suspensionItems = ((data.SuspensionList || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Agency: form.radio(xitem.Agency),
        AgencyExplanation: form.textarea(xitem.AgencyExplanation),
        AgencyNotApplicable: form.notapplicable(xitem.AgencyNotApplicable), // SF Only
        Date: form.datecontrol(xitem.Date),
        DateNotApplicable: form.notapplicable(xitem.DateNotApplicable),
        Outcome: form.text(xitem.Outcome),
        OutcomeExplanation: form.textarea(xitem.OutcomeExplanation),
        Explanation: form.textarea(xitem.Explanation),
        ReinstatedDate: form.datecontrol(xitem.ReinstatedDate),
        ReinstatedDateNotApplicable: form.notapplicable(xitem.ReinstatedDateNotApplicable),
      },
    };
  });
  return {
    HasRevocations: form.branch(data.HasRevocations),
    List: form.collection(items, (data.List || {}).branch),
    HasDenials: form.branch(data.HasDenials),
    DenialList: form.collection(denialItems, (data.DenialList || {}).branch),
    HasSuspensions: form.branch(data.HasSuspensions),
    SuspensionList: form.collection(suspensionItems, (data.SuspensionList || {}).branch),
  };
};
